// disabling eslint temporarily for legacy files until they can be refactored
/* eslint-disable */
import React from "react";
import { Col, Row } from "react-bootstrap";

export const GenericLegend = (props) => {
  const { labels, colors } = props;

  return (
    <>
      <Row className="widget4 pl-2 mt-2 ml-2" style={{ minHeight: "0px" }}>
        <Col>
          <ul className="legend pl-0 mt-2">
            {labels?.map((labelValue, index) => {
              return (
                <React.Fragment key={"legend-" + index}>
                  <span className="mr-3">
                    <span
                      className="bullet"
                      style={{ backgroundColor: colors[index] }}
                    />
                    <span className="font-color-6">{labelValue}</span>
                  </span>
                </React.Fragment>
              );
            })}
          </ul>
        </Col>
      </Row>
    </>
  );
};
